import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import config from '../../config';
import terms from '../../config/terminology';

export default function DonatorLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [logging, setLogging] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLogging(true);

    try {
      const loginRes = await fetch(`${config.API_URL}/donators/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include', // Include cookies
        body: JSON.stringify({
          email: formData.email,
          password: formData.password
        }),
      });

      if (!loginRes.ok) {
        const errorData = await loginRes.json();
        throw new Error(errorData.detail || 'Invalid email or password');
      }

      const loginData = await loginRes.json();
      console.log('Donator logged in:', loginData.donator);

      // Redirect to the page they were trying to access, or dashboard
      const from = location.state?.from?.pathname || '/donator-dashboard';
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLogging(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-black text-white justify-center items-center p-4">
      <form onSubmit={handleLogin} className="bg-gray-800 p-8 rounded-lg w-full max-w-md border border-blue-500 space-y-4">
        <h2 className="text-2xl font-bold text-center text-white mb-6">{terms.Donator} Sign In</h2>

        {error && (
          <div className="bg-red-900 border border-red-500 text-red-200 px-4 py-2 rounded">
            {error}
          </div>
        )}

        <input
          className="w-full p-2 bg-gray-900 border border-gray-600 rounded text-white placeholder-gray-400"
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <input
          className="w-full p-2 bg-gray-900 border border-gray-600 rounded text-white placeholder-gray-400"
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
        />

        <button
          className="w-full bg-blue-500 text-white p-3 rounded-lg font-semibold hover:bg-blue-600 transition disabled:bg-gray-600"
          type="submit"
          disabled={logging}
        >
          {logging ? 'Signing in...' : 'Sign In'}
        </button>

        <div className="text-center text-sm text-gray-400">
          <p>
            Sign in to save your information and payment methods for faster {terms.donations}.
          </p>
        </div>
      </form>
    </div>
  );
}